import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectHttpGetRoomsCurrentFloorResult } from "../Room/httpRoomSelectors";
import { setSelectedSpaceNumberInRedux } from "./designSlice";

/** Pick once on module entry, waiting for this floor's rooms if necessary. */
export function useInitialModuleRoom() {
  const dispatch = useAppDispatch();
  const module = useAppSelector(state => state.design.activeModule);
  const projectNo = useAppSelector(state => state.design.projectNo);
  const selectedRoom = useAppSelector(state => state.design.selectedSpaceNumber);
  const rooms = useAppSelector(selectHttpGetRoomsCurrentFloorResult);
  const currentEntry = useRef<{ key: string; handled: boolean } | null>(null);

  useEffect(() => {
    if (!module || !projectNo) {
      currentEntry.current = null;
      return;
    }
    const entry = `${projectNo}:${module}`;
    if (currentEntry.current?.key !== entry) currentEntry.current = { key: entry, handled: false };
    if (currentEntry.current.handled) return;
    if (selectedRoom != null) {
      currentEntry.current.handled = true;
      return;
    }
    const roomNumbers = Object.values(rooms).map(room => room.roomNumber).filter(Boolean);
    if (roomNumbers.length === 0) return;
    // URL restoration can select a room earlier in the same effect flush.
    currentEntry.current.handled = dispatch((dispatch, getState) => {
      const state = getState();
      if (state.design.selectedSpaceNumber != null) return true;
      const available = Object.values(selectHttpGetRoomsCurrentFloorResult(state))
        .map(room => room.roomNumber).filter(Boolean);
      if (available.length === 0) return false;
      dispatch(setSelectedSpaceNumberInRedux(available[Math.floor(Math.random() * available.length)]));
      return true;
    });
  }, [dispatch, module, projectNo, selectedRoom, rooms]);
}
